var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialog
    ? _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.type === "edit" ? "编辑" : "新增",
            visible: _vm.dialog,
            width: _vm.getIsMobile ? "100%" : "50%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "custom-form",
              attrs: {
                model: _vm.form,
                "label-width": "90px",
                "label-position": _vm.getIsMobile ? "top" : "right",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "账号", prop: "username" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入账号" },
                    model: {
                      value: _vm.form.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "username", $$v)
                      },
                      expression: "form.username",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "密码", prop: "password" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入密码" },
                    model: {
                      value: _vm.form.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "姓名", prop: "rname" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入姓名" },
                    model: {
                      value: _vm.form.rname,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "rname", $$v)
                      },
                      expression: "form.rname",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "QQ", prop: "qq" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入QQ号" },
                    model: {
                      value: _vm.form.qq,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "qq", $$v)
                      },
                      expression: "form.qq",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话", prop: "tel" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入联系电话" },
                    model: {
                      value: _vm.form.tel,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "tel", $$v)
                      },
                      expression: "form.tel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "编号", prop: "num" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入编号" },
                    model: {
                      value: _vm.form.num,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "num", $$v)
                      },
                      expression: "form.num",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重 置"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }